import { User } from "./user";

export enum ShipAddressType {
  Normal = 1, // 客户本社
  Complete = 2, // 代工厂
  Wasted = 3, // 中转仓
  Temporary = 4, // 客户
  Production = 5, // 其他
}
export enum ShipAddressDefault {
  No = 0,
  Yes = 1,
}

export interface ShipAddressTypeOption {
  key: ShipAddressType;
  desc: string;
}

export interface ShipAddressParams {
  name: string;
  address: string;
  phone?: string;
  country?: string;
  type: ShipAddressType;
  default: ShipAddressDefault;
  remark?: string;
}

export interface ShipAddress {
  id: string;
  customerId: string;
  name: string;
  address: string;
  phone?: string;
  country?: string;
  type: ShipAddressType;
  typeDesc: string;
  default: ShipAddressDefault;
  remark?: string;
  state: number;
  createdAt: number;
  createdBy: string;
  updatedAt: number;
  updatedBy: string;
  creator?: User | null;
  updater?: User | null;
}
